import {useEffect} from 'react';
import {useParams} from 'react-router';
import {useRecoilState, useRecoilValue} from 'recoil';
import {
  currentAnnouncementIdState,
  currentAnnouncementState,
  currentCompetitionIdState,
  currentCompetitionState,
  currentTemplateCompetitionState,
  currentVendorIdState,
  currentVendorState,
} from '../recoil/FirestoreRecoil';
import {
  currentLeagueIdState,
  currentLeagueState,
  currentMatchIdState,
} from '../recoil/LeaguesRecoil';

export const useGetCurrentCompForRoute = (isTemplateView: boolean = false) => {
  let paramCompId: string | undefined = useParams<{compId?: string}>().compId;
  const [compId, setCompId] = useRecoilState(currentCompetitionIdState);
  useEffect(() => {
    if (paramCompId) {
      setCompId(paramCompId);
    }
  }, [paramCompId, setCompId]);

  return {
    compId,
    competition: useRecoilValue(
      isTemplateView
        ? currentTemplateCompetitionState
        : currentCompetitionState,
    ),
  };
};

export const useGetCurrentAnnouncementForRoute = () => {
  let paramCompId: string | undefined = useParams<{announcementId?: string}>()
    .announcementId;
  const [announcementId, setAnnouncementId] = useRecoilState(
    currentAnnouncementIdState,
  );
  useEffect(() => {
    if (paramCompId) {
      setAnnouncementId(paramCompId);
    }
  }, [paramCompId, setAnnouncementId]);

  return {
    announcementId,
    announcement: useRecoilValue(currentAnnouncementState),
  };
};

export const useGetCurrentLeagueForRoute = () => {
  let paramLeagueId: string | undefined = useParams<{leagueId?: string}>()
    .leagueId;
  const [leagueId, setLeagueId] = useRecoilState(currentLeagueIdState);
  useEffect(() => {
    if (paramLeagueId) {
      setLeagueId(paramLeagueId);
    }
  }, [paramLeagueId, setLeagueId]);

  return {leagueId, leagueDetails: useRecoilValue(currentLeagueState)};
};

export const useGetCurrentVendorForRoute = () => {
  const paramVendorId = useParams<{vendorId?: string}>().vendorId;
  const [vendorId, setVendorId] = useRecoilState(currentVendorIdState);
  useEffect(() => {
    if (paramVendorId) {
      setVendorId(paramVendorId);
    }
  }, [paramVendorId, setVendorId]);

  return {vendorId, vendor: useRecoilValue(currentVendorState)};
};

export const useGetCurrentMatchIdForRoute = () => {
  let paramMatchId: string | undefined = useParams<{matchId?: string}>()
    .matchId;
  const [matchId, setMatchId] = useRecoilState(currentMatchIdState);
  useEffect(() => {
    if (paramMatchId) {
      setMatchId(decodeURIComponent(paramMatchId));
    }
  }, [paramMatchId, setMatchId]);

  return {matchId};
};
